import apiClient from '@/plugins/axios'

export default {
  getUsuarios() {
    return apiClient.get('usuario')
  },

  getUsuario(id) {
    return apiClient.get(`usuario/${id}`)
  },

  postUsuario(usuario) {
    return apiClient.post(`usuario`, { usuario })

  },

  putUsuario(id, usuario) {
    return apiClient.put(`usuario/${id}`, { usuario })

  },

  deleteUsuario(id) {
    return apiClient.delete(`usuario/${id}`)
  },

  getDropDown() {
    return apiClient.get(`usuario/dropdown`)
  }

}


// WEBPACK FOOTER //
// ./src/views/Usuario/_services/UsuarioService.js